const app = {
    state: {
        loginVisible: false,
    },
    mutations: {
        SET_LOGIN: (state, val) => {
          //  state.loginVisible = val;

             window.location.href = 'https://bmfw.jcgov.gov.cn/pc/authuser/page/login?appcode=51ab2898a5eb4962a8bfbb130e52c3d4&modulecode=123ae09b383b46cf9c90ec69b662b583'
            // window.location.href = 'http://bmfwtest.jcgov.gov.cn/pc/authuser/page/login?appcode=51ab2898a5eb4962a8bfbb130e52c3d4&modulecode=123ae09b383b46cf9c90ec69b662b583'

        },
    },
    actions: {
    }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js